<template>
  <div class="text-block block-card card-border">
    <v-expansion-panel expand :value="panel">
      <v-expansion-panel-content :lazy="lazyRendering">
        <template v-slot:header >
          <div class="block-card-title handle" >
            <div class="title-icon">
              <span class="botter-travel-icon white--text text-lg-2" />
            </div>

            <h4>
              Travel 
              <v-icon 
                v-if = "errorsCount.errorsCount" 
                color = "error" 
                style = "margin-left: 4px;">error</v-icon>
              <span class="text--error" v-if="!validData">(Invalid Card Data)</span>
            </h4>
          </div>
        </template>
        <div class="" v-if="validData">
          <form-validation v-model = "errorsCount">
          <div class="block-card-body">
            <label >Intro Message</label>
            <vTextareaAutocomplete
              v-model="data.introMessage"
              :type="'textfield'"
              :validationRules=" [v => !!v || 'Intro message is Required']"
            >
            </vTextareaAutocomplete>

            <label >Passengers</label>

            <v-combobox
              v-model="data.passengers"
              :items="[]"
              chips
              outline
              solo
              multiple
            >
            </v-combobox>

            <label >Confirmation number</label>
            <vTextareaAutocomplete
              v-model="data.confirmation_number"
              :type="'textfield'"
              :validationRules=" [v => !!v || 'confirmation number is Required']"
            >
            </vTextareaAutocomplete>

            <label >Currency</label>
            <vTextareaAutocomplete
              v-model="data.currency"
              :type="'textfield'"
              :validationRules=" [v => !!v || 'Currency number is Required']"
            >
            </vTextareaAutocomplete>

            <label >Details URL</label>
            <vTextareaAutocomplete
              v-model="data.details_url"
              :type="'textfield'"
              :validationRules=" [v => !!v || 'Details URL is Required']"
            >
            </vTextareaAutocomplete>
          </div>


          <div v-for="(stop,index) in data.flight_info" class="card-border full-width card-inner-wrapper">
            <h4 v-if="index === 0" class="mb-3">One way flight</h4>
            <h4 v-else-if="index === 1" class="mb-3">Two way flight</h4>
            <label class="mt-4">Flight number</label>
            <vTextareaAutocomplete v-model="stop.flight_number" :type="'textfield'"
                                   :validationRules=" [v => !!v || 'Flight number is Required']">
            </vTextareaAutocomplete>

              <label class="mt-4">Stops number</label>
              <vTextareaAutocomplete v-model="stop.stops_number" :type="'textfield'"
                                     :validationRules=" [v => !!v || 'Stops number is Required']">
              </vTextareaAutocomplete>


            <v-layout row v-if="data.flight_info" class="align-center">
              <v-flex sm4 class="pa-0">
                <label class="mt-4">Departure date</label>
                <vTextareaAutocomplete v-model="stop.departure_date" :type="'textfield'"
                                       :validationRules=" [v => !!v || 'Departure date is Required']">

                </vTextareaAutocomplete>
                <label class="mt-4">Departure Name</label>
                <vTextareaAutocomplete v-model="stop.departure_name" :type="'textfield'"
                                       :validationRules=" [v => !!v || 'Departure name is Required']">

                </vTextareaAutocomplete>
                <label class="mt-4">Departure acronym</label>
                <vTextareaAutocomplete v-model="stop.departure_acronym" :type="'textfield'"
                                       :validationRules=" [v => !!v || 'Departure acronym is Required']">

                </vTextareaAutocomplete>
              </v-flex>
              <v-flex sm4 class="text-sm-center">
                <v-icon color="primary" large>airplanemode_active</v-icon>
              </v-flex>
              <v-flex sm4 class="pa-0">
                <label class="mt-4">Arrival date</label>
                <vTextareaAutocomplete v-model="stop.arrival_date" :type="'textfield'"
                                       :validationRules=" [v => !!v || 'Arrival date is Required']">

                </vTextareaAutocomplete>
                <label class="mt-4">Arrival Name</label>
                <vTextareaAutocomplete v-model="stop.arrival_name" :type="'textfield'"
                                       :validationRules=" [v => !!v || 'Arrival name is Required']">

                </vTextareaAutocomplete>
                <label class="mt-4">Arrival acronym</label>
                <vTextareaAutocomplete v-model="stop.arrival_acronym" :type="'textfield'"
                                       :validationRules=" [v => !!v || 'Arrival acronym is Required']">

                </vTextareaAutocomplete>
              </v-flex>
            </v-layout>
            <v-btn
              @click="deleteStop(index)"
              fab small color=""
              v-if="index !== 0"
              class="delete-button"
            ><v-icon small color="#666">delete_outline</v-icon></v-btn>
          </div>

          <v-btn
            large round flat block
            class="primary--text"
            @click="addStop"
            v-if="data.flight_info && data.flight_info.length === 1"
          >
            <v-icon>add_circle_outline</v-icon>
            Add Return Flight
          </v-btn>



          <v-layout row v-if="">

            <v-flex sm12>
              <label class="mt-4">Total</label>
              <!--                            <v-text-field-->
              <!--                                    outline-->
              <!--                                    v-model="data.total"-->
              <!--                                    :error="!data.total"-->
              <!--                                    :error-messages="!data.total? 'Total is Required':''"-->
              <!--                            >-->
              <!--                            </v-text-field>-->
              <vTextareaAutocomplete v-model="data.total" :type="'textfield'"
                                     :validationRules=" [v => !!v || 'Total is Required']">

              </vTextareaAutocomplete>
            </v-flex>
          </v-layout>
        </form-validation>
        </div>
        <slot name = "tail" />
      </v-expansion-panel-content>
    </v-expansion-panel>
  </div>
</template>

<script>
  import common from "../../../../utils/common"
  import FormValidation from '../FormValidation'
  export default {
    name: "card-travel",
    components: {
      FormValidation
    },
    props: {
      data: {
        type: Object,
        default: ()=> {
          return {}
        }
      },
      index: {
        type: Number,
        default: ()=> {
          return 0
        }
      },
      blocksList: {
        type: Array,
        default: ()=> {
          return []
        }
      },
      validData: {
        type: Boolean,
        default: ()=> {
          return false
        }
      }
    },
    data() {
      return {
        valid: true,
        errorsCount: { errorsCount: 0 },
        lazyRendering: true,
        panel: 1,
        common
      }
    },
    mounted() {
      if (this.data.errorsCount !== undefined) {
      this.errorsCount = this.data.errorsCount
    } else {
      // disabling Lazy rendering so we can grip errors count
      this.lazyRendering = false
      setTimeout(() => {
        // then we turn it on again to keep the performance up
        this.lazyRendering = true
      }, 1000)
    }
    },
    methods: {
      addStop() {
        this.data.flight_info.push(
          {
            arrival_acronym: 'SLC',
            arrival_date: '2016-01-02T21:20',
            arrival_name: 'Salt Lake City',
            departure_acronym: 'SFO',
            departure_date: '2016-01-02T19:45',
            departure_name: 'San Francisco',
            flight_number: 41,
            stops_number: 'non stop'
          }
        )
      },
      deleteStop(index) {
        this.data.flight_info.splice(index, 1)
      }
    },
    computed: {

    },
    watch: {
      errorsCount(val) {
        this.$emit('input', { errorsCount: val.errorsCount })
        this.data.errorsCount = val.errorsCount
      }
    }
  }
</script>

<style scoped>

</style>
